export function Tag(item: any) {
  return item["#name"];
}

export function firstChildWithTag(data: any, tag: string): any | undefined {
  if (data) {
    for (let i in data.items) {
      const child = data.items[i];
      if (Tag(child) == tag) {
        return child;
      }
    }
  }

  return undefined;
}

export function AllChildsWithTag(data: any, tag: string): any | undefined {
  let childs: any = [];
  if (data) {
    for (let i in data.items) {
      const child = data.items[i];
      if (Tag(child) == tag) {
        childs.push(child);
      }
    }
  }
  if (childs.length > 0) return childs;
  else return undefined;
}

export function firstChildWithAtribute(data: any, attributeName: string, value: string): any | undefined {
  if (data) {
    for (let i in data.items) {
      const child = data.items[i];
      const c = child.a[attributeName];
      if (c == value) {
        return child;
      }
    }
  }

  return undefined;
}

export function getText0(data: any): string {
  if (data.ParameterBlock) {
    return getText(data.ParameterBlock[0]);
  } else {
    return data.a ? data.a.Text || "" : "";
  }
}

export function getText(data: any): string {
  return data.a ? data.a.Text || "" : "";
}

export function getName(data: any): string {
  return data.a ? data.a.name || data.a.Name || "" : "";
}

export function getId(data: any): string {
  return data.a ? data.a.Id || "" : "";
}

export function getRefId(data: any): string {
  return data.a ? data.a.RefId || "" : "";
}

export function getParamRefId(data: any): string {
  return data.a ? data.a.ParamRefId || "" : "";
}
